import { render } from "./VabeneAddProductPage.vue?vue&type=template&id=33be7c86&ts=true"
import script from "./VabeneAddProductPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__